import { logger } from './logger'

let vectorDbEndpoint: string | null = null
let vectorDbConfigured = false

export function configureVectorDb(endpoint: string) {
  vectorDbEndpoint = endpoint
  vectorDbConfigured = true
  logger.info('Vector DB configured', { endpoint })
}

export function isVectorDbConfigured(): boolean {
  return vectorDbConfigured
}

export async function queryVectorDb(query: string, topK: number = 5, category?: string): Promise<string> {
  if (!vectorDbEndpoint) {
    return ''
  }

  try {
    const body: any = { query, top_k: topK }
    if (category) body.category = category

    logger.debug('Querying Vector DB', { queryPreview: query.slice(0, 60), topK, category })
    const response = await fetch(vectorDbEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      signal: AbortSignal.timeout(8000),
    })

    if (!response.ok) {
      const errText = await response.text().catch(() => '')
      logger.warn('Vector DB returned non-ok status', { status: response.status, errText })
      throw new Error(`Vector DB returned ${response.status}: ${errText}`)
    }

    const data = await response.json()
    const results = Array.isArray(data) ? data : (data.results || [])
    logger.debug('Vector DB results', { resultCount: Array.isArray(results) ? results.length : 0 })

    if (!Array.isArray(results) || results.length === 0) {
      return ''
    }

    let context = '\n\n[VECTOR DATABASE — SCRIPTURE REFERENCES]:\n\n'
    for (const result of results) {
      const score = result.score !== undefined ? ` (score: ${result.score.toFixed(3)})` : ''
      const religion = result.religion || ''
      const category = result.category || ''
      const text = result.text || ''
      const label = religion ? `${religion} (${category})` : (result.source || 'Unknown')
      context += `--- ${label}${score}\n${text}\n\n`
    }

    return context
  } catch (err) {
    if (err instanceof DOMException && err.name === 'TimeoutError') {
      logger.warn('Vector DB query timed out', { endpoint: vectorDbEndpoint })
      throw new Error('Vector DB query timed out after 8s')
    }
    logger.captureException(err, { context: 'queryVectorDb', endpoint: vectorDbEndpoint })
    throw err
  }
}
